import React from "react";
import './articleHeader.css';
import Global from "../../global";
import Share from "../share/share";

const ArticleHeader = (props)=>
{
return(
<div>
<header className={Global.TYPE==="News"?"no-top-padding entry-header mb-2":"entry-header mb-2"} >
        <h1 className="entry-title">{props.title}</h1>
    </header>
    
    <ul className="post-meta-info">
        <li className="author">
          <a href="#!">
          {props.author}
          </a>
        </li>
        <li>
          <a href="#!">
            <i className="fa fa-clock-o" />
            {props.publishDate}
          </a>
        </li>
     
        {Global.SOS?  <li className="share-post">
          <a href="#!">
            <i className="ri-share-line " />
          </a>
          <Share type={"season"} details={props.details} article {...props}></Share>
        </li>:""}
      </ul>
</div>
  
    
);
}

export default ArticleHeader